import { render, staticRenderFns } from "./MapaBrasilAdmin.vue?vue&type=template&id=77949abb&"
import script from "./MapaBrasilAdmin.vue?vue&type=script&lang=js&"
export * from "./MapaBrasilAdmin.vue?vue&type=script&lang=js&"
import style0 from "./MapaBrasilAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports